import { render, staticRenderFns } from "./MatchmakingPreferences.vue?vue&type=template&id=0fca7c04&scoped=true"
import script from "./MatchmakingPreferences.vue?vue&type=script&lang=js"
export * from "./MatchmakingPreferences.vue?vue&type=script&lang=js"
import style0 from "./MatchmakingPreferences.vue?vue&type=style&index=0&id=0fca7c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca7c04",
  null
  
)

export default component.exports